module.exports = __webpack_public_path__ + "static/assets/28635f4d9e1e97e1e4484ba3c6de3b6c.svg";